var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention, camelcase -- keys are the Rails request params and response body */
import api from '@utils/axios';
import { AssigneeType } from '@enums/assignee-type.enum';
const JSON_HEADERS = { Accept: 'application/json' };
const ID_PLACEHOLDER = ':id';
const CONFLICT_STATUS = 409;
export function visitPayload(inspectionId, values) {
    var _a;
    const isSubcontractor = values.assigneeType === AssigneeType.SUBCONTRACTOR;
    return {
        visit: Object.assign(Object.assign({ inspection_id: inspectionId, assignee_type: values.assigneeType, [isSubcontractor ? 'subcontractor_id' : 'technician_id']: (_a = (isSubcontractor ? values.subcontractorId : values.technicianId)) !== null && _a !== void 0 ? _a : '' }, (isSubcontractor && values.subcontractorId === null && { technician_id: '' })), { scheduled_date: values.scheduledDate, scheduled_time: values.scheduledTime, duration: values.duration, priority: values.priority, priority_note: values.priorityNote, time_zone_override: values.timeZone, visit_notes: values.visitNotes })
    };
}
/** Resolves with the saved visit as a list row. */
export function createVisit(url, inspectionId, values, includeSeriesScope) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = Object.assign(Object.assign({}, visitPayload(inspectionId, values)), (includeSeriesScope && { update_all: values.updateAll }));
        const { data } = yield api.post(url, body, { headers: JSON_HEADERS });
        return data.visit;
    });
}
/** Resolves with the saved visit as a list row. */
export function updateVisit(url, id, inspectionId, values) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.patch(url.replace(ID_PLACEHOLDER, String(id)), visitPayload(inspectionId, values), { headers: JSON_HEADERS });
        return data.visit;
    });
}
/** `in_place` tells the server the page shows its own notice, so it sets no flash for the next page. */
export function destroyVisit(url, id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(url.replace(ID_PLACEHOLDER, String(id)), { headers: JSON_HEADERS, params: { in_place: true } });
    });
}
/** Resolves with the conflict when the technician is not available, or null when everything is clear. */
export function checkAvailability(url, params, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            yield api.get(url, {
                signal,
                headers: JSON_HEADERS,
                params: {
                    technician_id: params.technicianId,
                    scheduled_date: params.scheduledDate,
                    scheduled_time: params.scheduledTime,
                    duration: params.duration,
                    time_zone: params.timeZone,
                    default_object_name: 'Visit',
                    default_object_id: params.visitId
                }
            });
            return null;
        }
        catch (error) {
            const { response } = error;
            if ((response === null || response === void 0 ? void 0 : response.status) !== CONFLICT_STATUS || !((_a = response.data) === null || _a === void 0 ? void 0 : _a.message))
                throw error;
            const { message, data } = response.data;
            return { message, link: (data === null || data === void 0 ? void 0 : data.link) ? { href: data.link, text: (_b = data.text_link) !== null && _b !== void 0 ? _b : data.link } : undefined };
        }
    });
}
